export default "__VITE_ASSET__CdXw0cBy__"